import React from 'react';
import CalendarItemChip from './CalendarItemChip';
import { isSameDay, toISODate } from './calendarConstants';
import { todayAsLocalDate } from '../../shared/tenantClock';

const MAX_VISIBLE_MONTH = 3;

// One day box in either grid — month view caps visible chips (a packed day
// otherwise blows out the row height); week view has more vertical room, so
// shows everything (Week/Fortnight pass minHeight 0 and stretch to their
// grid's shared height instead). Also a drop target for a dragged Task chip (see
// DashboardCalendar's handleTaskDrop) — same onDragOver/onDrop shape as
// CustomerPipelinePage's Stage columns.
function CalendarDayCell({
  date, items, inCurrentMonth = true, compact = false, minHeight = 240,
  draggingTaskId, dragOverDate, setDragOverDate, onDragStartTask, onDragEndTask, onDropTask,
}) {
  const today = isSameDay(date, todayAsLocalDate());
  const iso = toISODate(date);
  const isDragOver = draggingTaskId && dragOverDate === iso;
  const visibleItems = compact && items.length > MAX_VISIBLE_MONTH ? items.slice(0, MAX_VISIBLE_MONTH) : items;
  const hiddenCount = items.length - visibleItems.length;

  return (
    <div
      onDragOver={draggingTaskId ? (e) => { e.preventDefault(); setDragOverDate(iso); } : undefined}
      onDragLeave={draggingTaskId ? () => setDragOverDate((cur) => (cur === iso ? null : cur)) : undefined}
      onDrop={draggingTaskId ? (e) => { e.preventDefault(); onDropTask(iso); } : undefined}
      style={{
        minHeight: compact ? 88 : minHeight,
        padding: 6,
        background: isDragOver ? '#e3ecfa' : (inCurrentMonth ? '#fff' : '#fafafa'),
        border: '1px solid #eceef1',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        overflow: 'hidden',
      }}
    >
      <span
        style={{
          alignSelf: 'flex-start',
          fontSize: 12,
          fontWeight: today ? 700 : 500,
          color: today ? '#fff' : (inCurrentMonth ? '#333' : '#b3bbc7'),
          background: today ? '#1976d2' : 'transparent',
          borderRadius: '50%',
          width: 20,
          height: 20,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {date.getDate()}
      </span>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 3, overflow: 'hidden' }}>
        {visibleItems.map((item) => (
          <CalendarItemChip
            key={item.id}
            item={item}
            isDragging={draggingTaskId === item.id}
            onDragStartTask={onDragStartTask}
            onDragEndTask={onDragEndTask}
          />
        ))}
        {hiddenCount > 0 && (
          <span style={{ fontSize: 11, color: '#9aa5b5', paddingLeft: 4 }}>+{hiddenCount} more</span>
        )}
      </div>
    </div>
  );
}

export default CalendarDayCell;
